import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Picker } from "@react-native-picker/picker";
import { Dimensions } from "react-native";
import { Dropdown } from "react-native-element-dropdown";
import { globalFontStyle } from "../../assets/Font/FontFamily";
import { home_sort } from "../../utils/images";
import Colors from "../../assets/Color/Colors";
import FastImage from "../../common/FastImage";
import { globalImport } from "../../common/globalImports";
import RadioButton from "../RadioButton";
import Width from "../../assets/Width";
import { globalStyle } from "../../assets";
import { isMobile } from "../../utils/commonMethods";
import {
  globalConfigurableData,
  GlobalScreens,
} from "../../utils/globalConstant";
import FormTextLabel from "../FormTextLabel";

const { width, height } = Dimensions.get("window");

const DropDown = (props) => {
  const {
    imageSrc,
    isRightIcon,
    label,
    selectedData,
    pickerlist,
    onValueChange,
    isLeftIcon = true,
    addMoney = false,
    isMarketDropdown = false,
    translate= false,
    customStyle = {},
  } = props;

  return (
    <View>
      <Dropdown
        style={[
          styles.dropdown,
          addMoney ? styles.addMoney : null,
          isLeftIcon ? styles.sortFilter : null,
          isMarketDropdown ? { width: 70 } : null,
          customStyle.container,
        ]}
        containerStyle={[
          styles.dropdownContainer,
          isLeftIcon ? null : { width: 250 },
          addMoney ? { width: 250 } : null,
          isMarketDropdown && isMobile() ? styles.dropdownMarketLimit : null,
        ]}
        placeholderStyle={styles.placeholderStyle}
        selectedTextStyle={[
          globalFontStyle.appFontSubHeading,
          styles.selectedTextStyle,
          customStyle.text,
        ]}
        activeColor={GlobalScreens?.Home.dropdownBgColor}
        inputSearchStyle={styles.inputSearchStyle}
        iconStyle={styles.iconStyle}
        data={pickerlist}
        renderItem={(item, selected) => {
          return (
            <View
              style={[styles.radioOuterBox]}
              activeOpacity={0.8}
              key={item?.label}
            >
              <RadioButton isSelected={selected} btnColor={GlobalScreens?.Home.dropdownRadioBtnColor}/>
              <FormTextLabel labelStyles={{color: globalConfigurableData.primaryTextColor, marginLeft: 15 }} label={item?.label} />
            </View>
          );
        }}
        maxHeight={300}
        labelField={globalImport.isWeb && isLeftIcon ? "" : "label"}
        valueField="value"
        value={selectedData}
        //placeholder={!isFocus ? 'Select item' : '...'}

        onChange={(item) => {
          onValueChange(item.value);
          //setValue(item.value);
          //setIsFocus(false);
        }}
        renderLeftIcon={() =>
          isLeftIcon && (
            <FastImage
              style={{ width: 20, height: 20 }}
              source={globalConfigurableData.sortIcon()}
            />
          )
        }
        renderRightIcon={isLeftIcon ? () => isLeftIcon && <View /> : false}
      />
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    padding: 16,
  },
  addMoney: {
    width: Dimensions.get("window").width - 34,
  },
  dropdown: {
    height: 40,
    borderRadius: 100,
    width: 120,
    paddingVertical: 11,
  },
  dropdownContainer: {
    backgroundColor: GlobalScreens?.Home.dropdownBgColor,
    borderRadius: 5,
    top: 0,
    width: 180,
    paddingHorizontal: 8,
    paddingVertical: 8,
    borderColor: globalConfigurableData.borderColor,
  },
  dropdownMarketLimit: {
    backgroundColor: GlobalScreens?.Home.dropdownBgColor,
    borderRadius: 8,
    position: "relative",
    top: 5,
    width: 140,
    left: Width.width - 150,
    paddingHorizontal: 8,
    paddingVertical: 8,
  },
  radioOuterBox: {
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 12,
    //borderRadius: 12,
    alignItems: "center",
    //
    // borderColor: "rgba(134, 134, 133, 1)",
    // borderBottomWidth: 0.4,
  },
  sortFilter: {
    borderRadius: 100,
    width: 50,
    height: 36,
    marginRight: 10,
    ...globalStyle.outerElementBox,
    backgroundColor: GlobalScreens?.Home.dropdownBgColor,
    borderColor: globalConfigurableData.borderColor,
  },
  icon: {
    marginRight: 5,
  },
  label: {
    position: "absolute",
    backgroundColor: "white",
    left: 22,
    top: 8,
    zIndex: 999,
    paddingHorizontal: 8,
    fontSize: 14,
  },
  placeholderStyle: {
    fontSize: 16,
  },
  selectedTextStyle: {
    color: globalConfigurableData.tertiaryTextColor1,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
  },
});
export default DropDown;
